import {Role} from "@leap4/auth";

export const baseBackendRoute: string = process.env.REACT_APP_AUTH_SERVER_BASE_URL + "";
export const baseAuthServerUrl: string = baseBackendRoute;
export const organizationPartnersUrl = baseBackendRoute + '/organizations/partners'

if (!baseBackendRoute) {
    throw new Error("Invalid backend base route.")
}

export const BACKEND_SERVICE_NAME = "auth-server";
export const redirectUrlForAuthenticated = "/users"
export const requiredAuthRoles: Role[] = [Role.ADMIN];

// All this routes against the auth-server.
export const meUrl = baseBackendRoute + "/app/me";
export const meMultiUrl = baseBackendRoute + "/app/me_multi"
export const setCookieUrl = baseBackendRoute + "/app/set-cookie";
export const loginUrl = (process.env.REACT_APP_AUTH_SERVER_BASE_URL || "https://api.auth.adte-system.com") + "/users/login";
